/**
 * @desc new load embedded media script, it lazyloads embedded media
 * html example
 * js init example: novicell.embed.loadEmbeds();
 * @author Tommy Pedersen - TPE
 * @return generates preplay image
 * @requires jquery@1.11.3
 * @note: Just beautiful!
 */

 function getCookie(name, value) {
    var value = ";" + document.cookie;
    var parts = value.split("; " + name + "=" );
    if (parts.length === 2) {
        return parts.pop().split(";").shift();
   }
   return "";
  }


function containsSRC() {

    var getIframes = document.querySelectorAll("iframe");
    for (var i = 0; i < getIframes.length; i++) {
        var iframe = getIframes[i];

        console.log("test", getCookie("OptanonConsent", "value"));

        if (getCookie("OptanonConsent").includes('C0001%3A1%2CC0004%3A1')) {
            var cookieMessage = document.querySelectorAll('.cookieconsent-optout-statistics');
            for (var k = 0; k < cookieMessage.length; k++) {
                var message = cookieMessage[k];
                message.classList.add('hidden');
            }

             break; 
        }
    }
}
window.onload = containsSRC();


document.querySelector("body").addEventListener("click", function (e) {
    if (e.target.id === "accept-recommended-btn-handler" || e.target.classList.contains("save-preference-btn-handler") || e.target.id === "onetrust-accept-btn-handler" || e.target.id === "onetrust-reject-all-handler") {
        window.location.reload();
    }
});


var novicell = novicell || {};

novicell.embed = novicell.embed || function () {
    var self = this;
    var lastRefreshWidth = 0;
    var refreshWidth = 50;

    this.loadEmbeds = function (callback) {
        $(".grid-embedmedia").each(function () {
            if (!$(this).find(".embed-media-item").hasClass("loaded")) {
                if ($(this).visible(true) || $(this).data("load") === "always") {
                    if ($(this).has(".embed-preview-image").length) {
                        $(this).find(".embed-preview-image").click(function () {
                            var video = $(this).parent().find('.js-overlay-content');
                            if ($(window).width() > 768) {
                                novicell.overlay.create({
                                    'element': video[0],
                                    'class': 'selector-overlay',
                                });
                                self.lazyEmbed($('.selector-overlay').find(".embed-media-item"));
                            } else {
                                $(this).attr("style", "display: none!important");
                                $(this).closest(".grid-embedmedia").find("i").attr("style", "display: none!important");
                                self.lazyEmbed($(this).parent().find(".embed-media-item"));
                            }

                            if (typeof callback == 'function') {
                                callback();
                            }
                        });
                    } else {
                        self.lazyEmbed($(this).find(".embed-media-item"));
                        if (typeof callback == 'function') {
                            callback();
                        }
                    }
                }
            }
        });
    }

    this.onResize = function (callback) {
        if (window.innerWidth > lastRefreshWidth + refreshWidth || window.innerWidth < lastRefreshWidth - refreshWidth) {
            $('.grid-embedmedia').each(function () {
                if (!$(this).has(".embed-preview-image").length) {
                    self.lazyEmbed($(this).find(".embed-media-item"));
                    if (typeof callback == 'function') {
                        callback();
                    }
                }
            });
            lastRefreshWidth = window.innerWidth;
        }
    }

    this.lazyEmbed = function (figure) {
        figure.attr("style", "display: block!important");
        figure.addClass('loaded');
        var $embed = figure.find(".embed");
        var ratio, src, width;
        width = figure.width() != 0 ? figure.width() : $(figure).parent().width();
        ratio = $embed.data("ratio");
        src = $embed.data("src");
        $embed.attr("src", src);
        $embed.attr("width", width);
        $embed.attr("height", width * ratio);
    }

    this.backofficeEmbeds = function (callback) {
        $(".grid-embedmedia").each(function () {
            $(this).find(".embed-preview-image").remove();
            self.lazyEmbed($(this).find(".embed-media-item"));
            $(this).find(".embed").attr("src", self.updateQueryStringParameter($(this).find(".embed").data("src"), "autoplay", "false"))
            if (typeof callback == 'function') {
                callback();
            }
        });
    }

    this.updateQueryStringParameter = function (uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
            return uri + separator + key + "=" + value;
        }
    }

    // public functions:
    return {
        loadEmbeds: loadEmbeds,
        backofficeEmbeds: backofficeEmbeds,
        onResize: onResize
    };
}();

(function ($) {

    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *     the user visible viewport of a web browser.
     *     only accounts for vertical position, not horizontal.
     */

    $.fn.visible = function (partial) {

        var $t = $(this),
            $w = $(window),
            viewTop = $w.scrollTop(),
            viewBottom = viewTop + $w.height(),
            _top = $t.offset().top,
            _bottom = _top + $t.height(),
            compareTop = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;

        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

    };

})(jQuery);